export interface User {
  id: string;
  uuid: string;
  name: string;
  email: string;
  avatar?: string;
  bio?: string;
  createdAt: string;
  updatedAt: string;
}

export interface Comment {
    id: string;
    author: User;
    content: string;
    postId: string;
    createdAt: string;
    updatedAt: string;
}

export interface Post {
  id: string;
  title: string;
  content: string;
  author: User;
  category: 'article' | 'job' | 'column';
  tags: string[];
  createdAt: string;
  updatedAt: string;
}

export interface NewsSource {
  id: string;
  name: string;
  url: string;
  type: string;
  update_frequency: string;
  last_updated: string;
  is_active: boolean;
}

export interface NewsTopic {
  id: string;
  name: string;
  description?: string;
  parent_id?: string;
}

export interface NewsArticle {
  id: string;
  title: string;
  content: string;
  source_id?: string;
  topic_id?: string;
  published_at: string;
  created_at: string;
  updated_at: string;
  article_metadata?: Record<string, any>;
  source?: NewsSource;
  topic?: NewsTopic;
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  skip: number;
  limit: number;
}

export interface BusinessCard {
  id: string;
  title: string;
  content: string;
  created_at: string;
  updated_at: string;
  card_metadata?: Record<string, any>;
}

export interface AgentStep {
  step_name: string;
  description: string;
  status: string;
  result?: string;
}

export interface CardAnalysisStatus {
  id: string;
  card_id: string;
  status: string;
  progress: number;
  current_step?: string;
  steps: AgentStep[];
  created_at: string;
  updated_at: string;
}

export interface CardStructuredData {
  country?: string;
  company_name?: string;
  contact_name?: string;
  position?: string;
  phone?: string;
  email?: string;
  company_website?: string;
  address?: string;
  rating?: string;
  notes?: string;
  image_url?: string;
}

export interface CardReportContent {
  personal_report: string;
  company_report: string;
  structured_data: CardStructuredData;
}

export interface CardAnalysisReport {
  id: string;
  card_id: string;
  report_content: string;
  created_at: string;
}

export interface CardAnalysisReportWithData extends CardAnalysisReport {
  report_data?: CardReportContent;
}

export enum CardBatchExportFormat {
  CSV = "csv",
  XLSX = "xlsx",
  PDF = "pdf"
}

export interface CardBatchExportRequest {
  card_ids: string[];
  format: CardBatchExportFormat;
}

export interface CardAnalysisUpdate {
  status: string;
  message?: string;
  data?: {
    progress?: number;
    current_step?: string;
    steps?: AgentStep[];
    report_id?: string;
    report_ids?: string[];
    current_card_index?: number;
    total_cards?: number;
    overall_progress?: number;
    card_id?: string;
  };
}
